(() => {
  const video = document.querySelector('.bbx-home .bbxh-hero__video');

  if (!video) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncPlayback = () => {
    if (reducedMotion.matches || document.hidden) {
      video.pause();
      return;
    }

    const playback = video.play();
    if (playback) playback.catch(() => {});
  };

  syncPlayback();
  document.addEventListener('visibilitychange', syncPlayback);
  reducedMotion.addEventListener('change', syncPlayback);
})();
